// extracted by mini-css-extract-plugin
export var cardContainer = "_rj-0";
export var cardHeader = "_rj-2";
export var collapsedState = "_rj-3";
export var dragHandle = "_rj-5";
export var dragHandleIcon = "_rj-6";
export var dragging = "_rj-1";
export var titleArea = "_rj-4";